import React from 'react';

import fetch from '../fetch';


import utils from '../../utils';

import {Modal, message} from 'antd';

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + ''
        };

        if(d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

const DataGrid = {
    selections: [],
    data: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {
        key:'$index', 
        label: '序号'
    },
    {
        key:'categoryName', 
        width: 100, 
        label: '分类名称'
    },
    {
        key: 'fileTypesDesc',
        label: '文件类型',
        width: 80
    },
    {
        key: 'categoryOrder',
        label: '排序',
        width: 80
    },
    {
        key: 'categoryDesc',
        label: '描述',
        width: 250
    },
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords) => {
    const id = keywords.folderId
    if(!id) {
        return new Promise(() => {
            const list = (Object.assign({
                result: [].map(item => {
                    return Object.assign({}, item, {
                        height: (item.choices || []).length * 30
                    })
                }),
                selects: [].map(d => ({
                    value: d.id,
                    checked: false,
                    height: (d.choices || []).length * 30
                })),
                checked: false,
                total: data.total,
                pageIndex: data.pageNum,
                pageSize: data.pageSize,
                notify: [].length ? '' : '暂无数据...'
            }));
            return list; 
        })
    }
    return fetch.post(`project/category/list`,keywords = {pageNum: 1, pageSize: 100,folderId:`${id}`})
    .then(response => {
        return response.payload.data;
    })
    .then(data => {
        const list = (Object.assign({
            result: (data.dataList || []).map(item => {
                return Object.assign({}, item, {
                    height: height((item.optionList || []))
                })
            }),
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
                height: height((d.optionList || []))
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        }));
        DataGrid.data = list.result;
        return list;
    });
}

const height = ((optionList) => {
    
    var row = optionList.length;
    optionList.map(item => {
        item.isRanking?(
            item.rankDetailList?(
                item.rankDetailList.map(r=>{
                    r.isRanking?(
                        row += 1
                    ):''
                })
            ):''
        ):''
    })
    return row * 30;
});

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('project/category/insert', data);
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('project/category/update/' + id, data);
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('project/category/delete/', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.selections = [];
                        DataGrid.refresh();
                        callback();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method getSelection
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getSelection = () => {
    return DataGrid.selections;
}

const getUserSelectData = () => {
    const id = DataGrid.selections[0]
    return DataGrid.data.find(d => d.id === id)
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    
};

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('project/category/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        // console.log('error');
    });
}

const deleteFile = (dataList) => {
    const ids = dataList.map(d => d.id);
    return fetch.post('project/category/file/delete', ids);
}

export default {
    insert,
    update,
    querySearch,
    remove,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    batchUpdate,
    getSelection,
    getUserSelectData,
    redirect,
    querySearchById,
    download : `${fetch.base}project/category/file/download/`,
    upload: `${fetch.base}project/category/file`,
    deleteFile,
}